export default __webpack_public_path__ + "7e46f254815c6a04bf6c19a2afa8798b.pdf";